import { defaultSpeakableRubric } from './useRubrics'
import { useProfileUser } from './useUser'

export function useDefaultRubricId() {
  const profile = useProfileUser()

  return profile.defaultRubricId ?? defaultSpeakableRubric
}
